import Cookies from 'universal-cookie';

/**
 * Gets the landing page attached to a form
 * --
 * Note right now its not passed into the form, so we have to look at cookies
 */
export default function getLandingPage(_form) {
  return (new Cookies()).get('landing_page') || '';
}




// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/metadata/get_landing_page.js